export type OwnershipStripeReconnectTierInput = {
  tierId: string;
  stripeProductId?: string | null;
  stripeMonthlyPriceId?: string | null;
  stripeAnnualPriceId?: string | null;
  stripeLifetimePriceId?: string | null;
};

export function validateOwnershipStripeReconnectInput(params: {
  tiers: OwnershipStripeReconnectTierInput[];
  expectedTierIds: string[];
}): { ok: true } | { ok: false; message: string } {
  if (params.expectedTierIds.length === 0) {
    return { ok: false, message: 'No membership tiers found for this Circle' };
  }

  const providedIds = new Set(params.tiers.map((tier) => tier.tierId));
  for (const tierId of params.expectedTierIds) {
    if (!providedIds.has(tierId)) {
      return { ok: false, message: 'Every membership tier must be mapped in the Stripe reconnect wizard' };
    }
  }

  for (const tier of params.tiers) {
    if (!tier.stripeProductId?.trim()) {
      return { ok: false, message: 'Each tier requires a Stripe product ID' };
    }
  }

  return { ok: true };
}

export function ownershipTransferRequiresStripeReconnect(params: {
  transferStatus: string;
  accessType: string;
  stripeReconnectCompletedAt?: Date | string | null;
}): boolean {
  if (params.transferStatus !== 'accepted') return false;
  if (params.accessType !== 'paid') return false;
  return params.stripeReconnectCompletedAt == null;
}
